<template>
  <div :class="$style.base">
    <BaseButton
      icon="arrow-left"
      color="inverted"
      @click="onPrevious"
      v-test="'previousButton'"
    />
    <BaseDatePicker
      v-model="date"
      onlyPastDates
      :minValue="minDate"
      :range="year ? 'year' : 'month'"
      v-test="'dateSelect'"
    />
    <BaseButton
      :disabled="isDisabled"
      icon="arrow-right"
      color="inverted"
      @click="onNext"
      v-test="'nextButton'"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import dayjs from '@/dayjs';

export default defineComponent({
  props: {
    year: {
      type: Boolean,
      default: false,
    },
    month: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['change'],

  data() {
    return {
      date: dayjs(),
    };
  },

  watch: {
    dateString() {
      this.change();
    },
  },

  computed: {
    datePart() {
      return this.year ? 'year' : 'month';
    },

    isDisabled() {
      return this.date.format() === dayjs().format();
    },
    minDate() {
      return dayjs('2000-01-01').format();
    },
    dateString() {
      return this.date.format();
    },
  },

  methods: {
    change() {
      this.$emit('change', this.date);
    },

    onNext() {
      this.date = this.date.add(1, this.datePart);
    },

    onPrevious() {
      this.date = this.date.subtract(1, this.datePart);
    },
  },
});
</script>

<style
  lang="scss"
  module
>
.base {
  display: flex;
  align-items: flex-end;
  gap: $spacing * 0.5;
}

.selected {
  min-width: 100px;
}

.month {
  min-width: 170px;
}
</style>
